export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11186__CHANGE': '% Change',
    '_9589_CURRENT': 'Current',
    '_9796_PREVIOUS': 'Previous',
    '_10094_WINNING_PERCENTAGE': 'Winning %'
};
